import { useGateValue } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Returns `true` if either the local feature flag
 * ("enable-openapi-v2-key-self-serve") or the Statsig feature gate
 * ("enable_openapi_v2_key_self_serve") is enabled. The local flag is the
 * override the team can flip without touching Statsig; the gate drives the
 * tiered rollout.
 */
export const useEnableOpenApiV2KeySelfServe = (): boolean => {
  const featureFlag = useFeatureFlag("enable-openapi-v2-key-self-serve");
  const featureGate = useGateValue("enable_openapi_v2_key_self_serve");
  return featureFlag || featureGate;
};
